import { Outlet } from 'react-router-dom';

export const ExternalOutlet = () => <Outlet />;
